import {fetchLeaders, fetchLeadersFailed, fetchLeadersSuccess} from "modules/actions/leaders";
import {RequestState} from "modules/enums";
import {createReducer} from "redux-act";

interface ILeadersStore {
	leaders: ReturnType<typeof fetchLeadersSuccess>["payload"];
	requestState: RequestState;
}

const defaultState: ILeadersStore = {
	leaders: {
		leaders: [],
		nextPage: false,
	},
	requestState: RequestState.IDLE,
};

export const leaders = createReducer({}, defaultState)
	.on(fetchLeadersSuccess, (state, payload) => ({
		...state,
		leaders: payload,
		requestState: RequestState.RECEIVED,
	}))
	.on(fetchLeaders, (state) => ({
		...state,
		requestState: RequestState.REQUESTED,
	}))
	.on(fetchLeadersFailed, () => ({
		...defaultState,
		requestState: RequestState.RECEIVED,
	}));
